/** Token do link de e-mail, lido do fragmento da URL (`#token=…`); `null` se ausente. */
export function tokenFromHash(hash: string): string | null {
  const token = new URLSearchParams(hash.replace(/^#/, '')).get('token');
  return token === null || token === '' ? null : token;
}
